import { AdviceNavigationButton } from "../partials/buttons";
import { LeftArrowGray, RightArrowGray } from "../partials/icons";

export default {
  container: {
    padding: "10px 0",
    display: "flex",
    justifyContent: "center",
    "& .page-button": {
      ...AdviceNavigationButton
    },
    "& .gap-button": {
      ...AdviceNavigationButton
    },
    "& .navigation-next-button": {
      ...AdviceNavigationButton,
      marginLeft: "30px",
      "&:before": {
        ...RightArrowGray
      }
    },
    "& .navigation-back-button": {
      ...AdviceNavigationButton,
      marginRight: "30px",
      "&:before": {
        ...LeftArrowGray
      }
    },
    "& .selected": {
      fontWeight: "700"
    }
  }
};
